import React from 'react';
import styled from 'styled-components';
import { Loader } from 'semantic-ui-react';

export const MobilePageContent = styled.div.withConfig({
  shouldForwardProp: (prop: any) => prop === 'data-testid' || !prop.startsWith('data-'),
}).attrs({
  'data-mobile-scroll': true,
})`
  font-family: 'Poppins';
  font-style: normal;
  width: 100%;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  background-color: transparent;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 10px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

interface MobilePageSectionProps {
  padtop?: boolean | string;
  padbottom?: boolean | string;
}

export const MobilePageSection = styled.section<MobilePageSectionProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: ${({ padtop }) => (padtop ? (typeof padtop === 'string' ? padtop : '20px') : '0')};
  padding-bottom: ${({ padbottom }) => (padbottom ? (typeof padbottom === 'string' ? padbottom : '20px') : '0')};
  box-sizing: border-box;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px 0;
  line-height: 1.6;
`;

interface TitleProps {
  color?: string;
  padleft?: boolean | string;
  padright?: boolean | string;
  padtop?: boolean | string;
  padbottom?: boolean | string;
}

export const Title = styled.div<TitleProps>`
  position: relative;
  z-index: 2;
  font-family: 'Poppins';
  font-size: 22px;
  font-weight: 550;
  font-style: normal;
  color: ${props => props.color || '#414141'};
  ${props =>
    props.padtop && `padding-top: ${typeof props.padtop === 'string' ? props.padtop : '20px'};`};
  ${props =>
    props.padright &&
    `padding-right: ${typeof props.padright === 'string' ? props.padright : '25px'};`};
  ${props =>
    props.padbottom &&
    `padding-bottom: ${typeof props.padbottom === 'string' ? props.padbottom : '20px'};`};
  ${props =>
    props.padleft &&
    `padding-left: ${typeof props.padleft === 'string' ? props.padleft : '25px'};`};
`;

export const Subtitle = styled.div`
  font-size: 13px;
  color: #475569;
  font-weight: 550;
  line-height: 1.4;
`;

interface MobileSpinnerProps {
  text?: string;
  size?: 'mini' | 'tiny' | 'small' | 'medium' | 'large';
}

export const MobileSpinner = ({ text = '', size = 'large' }: MobileSpinnerProps) => (
  <MobileSpinnerWrapper>
    <Loader active size={size}>
      {text ? text : null}
    </Loader>
  </MobileSpinnerWrapper>
);

const MobileSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  width: 100%;
  padding: 24px 16px;
`;


export const BodyText = styled.div<{
  color?: string;
  padtop?: boolean | string;
  padbottom?: boolean | string;
}>`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${props => props.color || '#777'}; // Default to #777 if no color is provided
  ${props =>
    props.padtop && `padding-top: ${typeof props.padtop === 'string' ? props.padtop : '10px'};`};
  ${props =>
    props.padbottom &&
    `padding-bottom: ${typeof props.padbottom === 'string' ? props.padbottom : '10px'};`};
`;

export const FieldLabel = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 550;
  width: 250px;
  text-align: left;
  font-size: 12px;
  line-height: 18px;
  color: #333;
  margin-bottom: 3px;
`;

